import React, {useEffect, useRef, useState} from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import rightArrow from "../assets/images/right-arrow.webp";
import { Controller, useForm } from "react-hook-form";
import { Form, Button, InputGroup } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { useTranslation } from "react-i18next";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { toast } from "react-toastify";
import LayoutNew from "../components/shared/LayoutNew";

const SecurityCenter = () => {
  const sendOTP = useContextSelector(AuthContext, (ctx) => ctx.sendOTP);
  const setBr = useContextSelector(AuthContext, (ctx) => ctx.setBr);
  const lang = useContextSelector(AuthContext, (ctx) => ctx.lang);
  const setEn = useContextSelector(AuthContext, (ctx) => ctx.setEn);
  const logoutUser = useContextSelector(AuthContext, (ctx) => ctx.logoutUser);
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      countryCode: 91,
    },
  });
  const navigate = useNavigate();
  const onSubmit = async (body) => {
    set_password_same(true);
    if (body.password !== body.confirmPassword) {
      set_password_same(false);
    } else {
      const obj = {
        oldPassword: body?.oldpassword,
        newPassword: body?.confirmPassword,
      };
      const { status, data } = await apiPost(apiPath.changePassword, obj);
      if (status === 200) {
        if (data.success) {
          logoutUser();
          toast.success(data?.message);
        } else {
          toast.error(data?.message);
        }
      } else {
        toast.error(data?.message);
      }
    }
  };

  const [passwordType, setPasswordType] = useState("password");
  const togglePassword = (e) => {
    e.preventDefault();
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  const [password_same, set_password_same] = useState();

  const newPassword = useRef({});
  newPassword.current = watch("newPassword", "");
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xlinkHref="http://www.w3.org/1999/xlink"
        style={{ position: `absolute`, width: `0`, height: `0` }}
      >
        <defs>
           <symbol viewBox="0 0 36 36" id="form-icon-password_e999b917">
      <g id="form-icon-password_e999b917_icon-password">
        <path id="form-icon-password_e999b917_Union" fill-rule="evenodd" clip-rule="evenodd" d="M27.7474 15.8839V12.9692C27.7474 8.94419 26.7759 3.60059 18.3788 3.60059C9.98167 3.60059 9.01011 8.94419 9.01011 12.9692V15.8839C9.62081 15.8007 10.3148 15.759 11.092 15.7451V12.9692C11.092 8.59721 12.3273 5.68251 18.3788 5.68251C24.4302 5.68251 25.6655 8.59721 25.6655 12.9692V15.7451C26.4428 15.759 27.1367 15.8007 27.7474 15.8839ZM25.6662 15.7453C26.4435 15.7592 27.1375 15.8008 27.7482 15.8841C31.2874 16.3144 32.259 18.0493 32.259 22.6851V25.461C32.259 31.0128 30.8711 32.4007 25.3193 32.4007H11.4398C5.88795 32.4007 4.5 31.0128 4.5 25.461V22.6851C4.5 18.0493 5.47157 16.3144 9.01084 15.8841C9.62154 15.8008 10.3155 15.7592 11.0928 15.7453H25.6662ZM12.8277 25.461C13.1886 25.461 13.5494 25.3083 13.8131 25.0585C14.063 24.7947 14.2157 24.4339 14.2157 24.073C14.2157 23.8926 14.174 23.7121 14.1046 23.5456C14.0352 23.379 13.9381 23.2264 13.8131 23.0876C13.4245 22.6989 12.8138 22.574 12.3003 22.7961C12.1198 22.8655 11.9811 22.9627 11.8423 23.0876C11.7173 23.2264 11.6202 23.379 11.5508 23.5456C11.4814 23.7121 11.4398 23.8926 11.4398 24.073C11.4398 24.4339 11.5924 24.7947 11.8423 25.0585C11.9811 25.1834 12.1198 25.2805 12.3003 25.3499C12.4668 25.4193 12.6473 25.461 12.8277 25.461ZM19.3649 25.0585C19.4899 24.9197 19.587 24.767 19.6564 24.6004C19.7258 24.4339 19.7675 24.2534 19.7675 24.073C19.7675 23.6983 19.6148 23.3513 19.3649 23.0876C18.8375 22.574 17.9076 22.574 17.3941 23.0876C17.1442 23.3513 16.9916 23.6983 16.9916 24.073C16.9916 24.2534 17.0332 24.4339 17.1026 24.6004C17.172 24.767 17.2691 24.9197 17.3941 25.0585C17.6578 25.3083 18.0048 25.461 18.3795 25.461C18.7404 25.461 19.1012 25.3083 19.3649 25.0585ZM23.9313 25.461C24.2922 25.461 24.653 25.3083 24.9167 25.0585C25.1666 24.7947 25.3193 24.4339 25.3193 24.073C25.3193 23.9897 25.3054 23.8926 25.2915 23.7954C25.2776 23.7121 25.2499 23.6289 25.2082 23.5456C25.1805 23.4623 25.1388 23.379 25.0833 23.3096C25.0278 23.2264 24.9723 23.157 24.9168 23.0876L24.9167 23.0876C24.4032 22.574 23.4733 22.574 22.9459 23.0876C22.696 23.3513 22.5434 23.6983 22.5434 24.073C22.5434 24.4478 22.696 24.7947 22.9459 25.0585C23.2096 25.3083 23.5704 25.461 23.9313 25.461Z"></path>
      </g>
    </symbol>
        </defs>
      </svg>
      <LayoutNew>
        <div className="register-content">
          <div className="login-form active">
            <div className="forgot-back-header menu-header">
              <div className="left-arrow">
                <span onClick={() => navigate("/")}>
                  <img src={rightArrow} alt="" />
                </span>
              </div>
              <p>{t("Change Password")}</p>
            </div>
            <div className="reg-data">
              <Form onSubmit={handleSubmit(onSubmit)}>
                <div className="mb-2">
                  <Form.Group className="d-flex login-data-d">
                    <div style={{ position: "relative", width: `100%` }}>
                      <i class="input-icon">
                        <svg class="am-icon am-icon-form-icon-password_e999b917 am-icon-md">
                          <use xlinkHref="#form-icon-password_e999b917"></use>
                        </svg>
                      </i>

                      <Form.Control
                        type={passwordType ? passwordType : "password"}
                        placeholder="Enter Old Password"
                        className={errors.oldpassword ? " is-invalid " : ""}
                        {...register("oldpassword", {
                          required: "Please enter old password",
                          minLength: {
                            value: 8,
                            message:
                              "Password should contain atleast 8 characters",
                          },
                          maxLength: {
                            value: 16,
                            message:
                              "Password should contain maximum 16 characters",
                          },
                        })}
                      />

                      <div
                        className="input-group-btn"
                        style={{
                          position: "absolute",
                          right: "0",
                          top: "-10",
                          bottom: "9px",
                        }}
                      >
                        <span
                          className="btn btn-outline-primary"
                          onClick={togglePassword}
                          style={{
                            backgroundColor: "transparent",
                            border: "0",
                            padding: "8px",
                            paddingTop: "3px",
                            height: "72%",
                          }}
                        >
                          {passwordType === "password" ? (
                            <AiFillEyeInvisible color="#23ffc8" />
                          ) : (
                            <AiFillEye color="#23ffc8"/>
                          )}
                        </span>
                      </div>
                    </div>
                  </Form.Group>
                  {errors.oldpassword && errors.oldpassword.message && (
                    <div className="text-danger">
                      {errors.oldpassword.message}
                    </div>
                  )}
                  <Form.Group className="d-flex login-data-d">
                    <div style={{ position: "relative", width: `100%` }}>
                      <i class="input-icon">
                        <svg class="am-icon am-icon-form-icon-password_e999b917 am-icon-md">
                          <use xlinkHref="#form-icon-password_e999b917"></use>
                        </svg>
                      </i>

                      <Form.Control
                        type={passwordType ? passwordType : "password"}
                        placeholder="Enter Password"
                        className={errors.password ? " is-invalid " : ""}
                        {...register("password", {
                          required: "Please enter password",
                          minLength: {
                            value: 8,
                            message:
                              "Password should contain atleast 8 characters",
                          },
                          maxLength: {
                            value: 16,
                            message:
                              "Password should contain maximum 16 characters",
                          },
                        })}
                      />

                      <div
                        className="input-group-btn"
                        style={{
                          position: "absolute",
                          right: "0",
                          top: "-10",
                          bottom: "9px",
                        }}
                      >
                        <span
                          className="btn btn-outline-primary"
                          onClick={togglePassword}
                          style={{
                            backgroundColor: "transparent",
                            border: "0",
                            padding: "8px",
                            paddingTop: "3px",
                            height: "72%",
                          }}
                        >
                          {passwordType === "password" ? (
                            <AiFillEyeInvisible color="#23ffc8"/>
                          ) : (
                            <AiFillEye color="#23ffc8"/>
                          )}
                        </span>
                      </div>
                    </div>
                  </Form.Group>
                  {errors.password && errors.password.message && (
                    <div className="text-danger">{errors.password.message}</div>
                  )}
                  <Form.Group className="d-flex login-data-d">
                    <div style={{ position: "relative", width: `100%` }}>
                      <i class="input-icon">
                        <svg class="am-icon am-icon-form-icon-password_e999b917 am-icon-md">
                          <use xlinkHref="#form-icon-password_e999b917"></use>
                        </svg>
                      </i>

                      <Form.Control
                        type={passwordType ? passwordType : "password"}
                        placeholder="Confirm Password"
                        className={errors.confirmPassword ? " is-invalid " : ""}
                        {...register("confirmPassword", {
                          required: "Please enter confirm password",
                        })}
                      />

                      <div
                        className="input-group-btn"
                        style={{
                          position: "absolute",
                          right: "0",
                          top: "-10",
                          bottom: "9px",
                        }}
                      >
                        <span
                          className="btn btn-outline-primary"
                          onClick={togglePassword}
                          style={{
                            backgroundColor: "transparent",
                            border: "0",
                            padding: "8px",
                            paddingTop: "3px",
                            height: "72%",
                          }}
                        >
                          {passwordType === "password" ? (
                            <AiFillEyeInvisible color="#23ffc8"/>
                          ) : (
                            <AiFillEye color="#23ffc8"/>
                          )}
                        </span>
                      </div>
                    </div>
                  </Form.Group>
                  {errors.confirmPassword && errors.confirmPassword.message && (
                    <div className="text-danger">
                      {errors.confirmPassword.message}
                    </div>
                  )}
                  {password_same === false && errors.confirmPassword !== "" && (
                    <div className="text-danger">Password does not match.</div>
                  )}
                </div>

                <button type="submit" className="submit-btn">
                  <span>{t("Confirm")}</span>
                </button>
              </Form>
            </div>
          </div>
        </div>
      </LayoutNew>
    </>
  );
};

export default SecurityCenter;
